import type {PropsWithChildren} from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {useStripeElementsOptions, useStripeInstance} from '@chekin/shared/payments';
import {getEnvVariable} from '../configs';

function StripeProvider({children}: PropsWithChildren) {
  const options = useStripeElementsOptions();
  const {stripe, stripeAccount} = useStripeInstance({
    publishableKey: getEnvVariable('VITE_APP_STRIPE_API_KEY'),
  });

  return (
    <Elements stripe={stripe} key={stripeAccount} options={options}>
      {children}
    </Elements>
  );
}

export {StripeProvider};
